import { ShieldAlert } from "lucide-react";

// Supabase redirects here (to the Site URL) when an email link is invalid or
// expired, putting the reason in the URL *hash* — e.g.
// #error=access_denied&error_code=otp_expired&error_description=...
// App.tsx ignores the hash for routing, so without this the user lands on the
// homepage with no feedback. We surface a friendly message + a way forward.
export default function AuthErrorView({ code, description }: { code: string | null; description: string | null }) {
  const expired = code === "otp_expired";
  const heading = expired ? "Link abgelaufen." : "Link ungültig.";
  const body = expired
    ? "Dieser Bestätigungs- oder Anmeldelink ist abgelaufen oder wurde bereits verwendet. Fordere über die Anmeldung einen neuen an."
    : (description ?? "Dieser Link ist ungültig. Fordere über die Anmeldung einen neuen an.");

  return (
    <div className="min-h-screen bg-rc-cream text-rc-black flex flex-col items-center justify-center px-6 py-16 font-sans antialiased">
      <div className="w-full max-w-sm text-center animate-fade-up">
        <div className="w-12 h-12 rounded-full bg-rc-danger/10 border border-rc-danger/30 flex items-center justify-center mx-auto mb-7">
          <ShieldAlert className="w-5 h-5 text-rc-danger" />
        </div>
        <h1 className="text-[28px] font-bold text-rc-black tracking-[-0.02em] leading-[1.15] mb-3">
          {heading}
        </h1>
        <p className="text-rc-charcoal text-[15px] leading-[1.6]">{body}</p>
        <a
          href="/facilitator"
          className="mt-7 inline-flex items-center justify-center gap-2 bg-rc-berry hover:bg-rc-berry-700 text-rc-paper rounded-pill px-6 py-3 text-[15px] font-semibold active:scale-[0.98] transition ease-rc-out"
        >
          Zur Anmeldung
        </a>
      </div>
    </div>
  );
}
